import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@app/services/auth.service';

@Component({
    selector: 'register',
    templateUrl: './register.component.html'
})
export class RegisterComponent implements OnInit {
    formGroup: UntypedFormGroup;
    passwordGroup: UntypedFormGroup;
    showResult = false
    showPassword = false
    showPasswordBox: boolean = false

    @Input() thirPartyLogin = true
 
    constructor(private formBuilder: UntypedFormBuilder, private auth: AuthService, private router: Router) {}

    ngOnInit() {
        this.formGroup = this.formBuilder.group({
            email: ['', [
                Validators.required
            ]]
        });
        this.passwordGroup = this.formBuilder.group({
            email: ['', [
                Validators.required
            ]],
            password: ['', [
                Validators.required
            ]],
            confirmPassword: ['', [
                Validators.required
            ]]
        });
    }
 
    login() {
        this.auth.forgotUser(this.formGroup.value).subscribe((res:any)=>{
            this.showPasswordBox = true;
            this.passwordGroup.controls['email'].setValue(this.formGroup.controls.email.value)
        },(err:any)=>{
            this.showPasswordBox = false
          console.log(err);
        })
        console.log(this.formGroup);
    }
 
    setNewPassword() {
        if(this.passwordGroup.controls.password.value === this.passwordGroup.controls.confirmPassword.value)
        {
            this.auth.updateUser(this.passwordGroup.value).subscribe((res:any)=>{
                this.router.navigateByUrl('/login');
            },(err:any)=>{
            console.log(err);
            })
        }
        else{
            this.passwordGroup.controls['confirmPassword'].setValue('')
        }
    }

    onShowPasswordClick () {
        this.showPassword = !this.showPassword
    }
 
    onReset() {
        this.formGroup.reset();
    }
}
